/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Container from '@/components/Container';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import React from 'react';
import DefaultContentTemplateEmbedded from '@/components/DefaultContentTemplate/Embedded';
import { CourseEntity, Enum_Componentcommonembedded_Provider, Enum_Favorite_Type } from '@/graphql/generated/graphql';
import TitleWithActions from '@/components/TitleWithActions';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

export default function Highlight({
  image,
  video,
  title = '',
  description = '',
  button = '',
  cx,
}: {
  image?: string;
  video?: string;
  title?: string;
  description?: string;
  button?: React.ReactNode;
  cx: CourseEntity | null;
}) {
  const { src } = useResponsiveImage({ url: image || '', alternativeText: '' });

  if (!cx) {
    return null;
  }

  if (video) {
    return (
      <AnimatedFadeInComponent>
        <Container>
          <div className="col-span-12 lg:col-start-3 lg:col-end-11">
            <div className="relative flex flex-col gap-sh-15">
              <DefaultContentTemplateEmbedded
                className="mindful-video !my-0"
                fitContent
                component={{
                  id: 'DefaultContentTemplateEmbedded',
                  link: video,
                  provider: Enum_Componentcommonembedded_Provider.Youtube,
                }}
              />
              <TitleWithActions
                title={title || ''}
                entity={cx}
                entityId={cx?.id || '0'}
                type={Enum_Favorite_Type.Learn}
                like={false}
              />
              <p className="mt-0 font-aeonik text-sh-18-28">{description}</p>
              {button}
            </div>
          </div>
        </Container>
      </AnimatedFadeInComponent>
    );
  }

  return (
    <AnimatedFadeInComponent>
      <Container>
        <div className="col-span-12 flex flex-col items-start lg:col-start-11 lg:col-end-3">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-[415px_1fr]">
            <div className="flex aspect-video items-center  justify-center overflow-hidden rounded-2xl md:aspect-square">
              <img
                className="h-full max-h-[415px] w-full rounded-2xl object-cover object-center"
                src={src || ''}
                alt={src || ''}
              />
            </div>
            <div>
              <TitleWithActions
                title={title || ''}
                entity={cx}
                entityId={cx?.id || '0'}
                type={Enum_Favorite_Type.Learn}
                like={false}
              />
              <p className="mb-sh-15 mt-2 text-sh-xxs md:text-sh-sm">{description}</p>
              {button}
            </div>
          </div>
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
